import { State, selectAppPreview } from '../../index'

export const selectFollow = (state: State) => selectAppPreview(state).follow
export const selectFollowFirstStepData = (state: State) => selectFollow(state).step1
export const selectFollowInterpolationListData = (state: State) => selectFollow(state).interpolationListData
